import React from 'react';
import { BusyIndicator, Dialog, Text, Title } from '@ui5/webcomponents-react';

/**
 * Pantalla de carga bloqueante (subida de Excel de OV, envío a SAP, etc.).
 * Usa un `Dialog` de UI5: los diálogos UI5 v2 viven en la capa superior del navegador, así que un
 * `div` con `position: fixed` queda **detrás** de un modal abierto; un `Dialog` abierto después queda encima.
 * No se cierra con Escape: solo se cierra cuando `open` pasa a false.
 *
 * @param {{ open: boolean, title: string, message?: string }} props
 */
const BlockingLoadingDialog = ({ open, title, message }) => (
  <Dialog
    open={open}
    headerText=""
    style={{ width: 'min(480px, 92vw)' }}
    onBeforeClose={(e) => {
      if (e.detail?.escPressed) e.preventDefault();
    }}
  >
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.25rem',
        padding: '2rem 1.5rem',
        textAlign: 'center',
        cursor: 'wait'
      }}
    >
      <BusyIndicator active size="L" />
      <Title level="H4" style={{ margin: 0, textAlign: 'center', color: '#1565c0' }}>
        {title}
      </Title>
      {message ? (
        <Text style={{ maxWidth: 440, textAlign: 'center', color: '#37474f', lineHeight: 1.5 }}>
          {message}
        </Text>
      ) : null}
    </div>
  </Dialog>
);

export default BlockingLoadingDialog;
